import { render, staticRenderFns } from "./ColorsConceptSection.vue?vue&type=template&id=2cb3a6ae"
import script from "./ColorsConceptSection.vue?vue&type=script&lang=ts"
export * from "./ColorsConceptSection.vue?vue&type=script&lang=ts"
import style0 from "./ColorsConceptSection.vue?vue&type=style&index=0&id=2cb3a6ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports